module.exports = __webpack_public_path__ + "static/media/node.15c6f00d.png";